<template>
  <div>
    <div class="search-content" v-if="showlist">
      <el-col class="toobar">
        <el-col :span="2">
          <el-input size="mini"
            placeholder="请输入关键字"
            prefix-icon="el-icon-search" clearable
            v-model="searchdata">
          </el-input>
        </el-col>
        <el-col :span="3">
          <AutoCustomer @clear="clearCustomerName"  @handleSelect="afterSelExternalDept" :size="'mini'"></AutoCustomer>
          <!--<el-input @clear="clearCustomerName" :clearable="true" v-model="customername" placeholder="请选择门店"-->
          <!--@click.native="showSelectAllCustomerName"></el-input>-->
        </el-col>
        <el-col :span="3">
          <el-select v-model="servedserial" placeholder="服务部门" v-if="idd.length>1&&!isSupply()" size="mini">
            <el-option
              v-for="item in idd"
              :key="item.serialnum"
              :label="item.dname"
              :value="item.serialnum">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <CommonTree ref="treeDserial" :treeHeight="180" :searchText="serveuname" @check="changeServer" :inputSize="'mini'"
                      placeholder="请选业务员"
                      style="width: 100px"
                      :isShowCheckBox="false"></CommonTree>
        </el-col>
        <el-col :span="2">
          <el-select v-model="casestatus" placeholder="审批状态" size="mini">
            <el-option
              v-for="item in casestatuses"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-date-picker
            v-model="searchdatevalue" size="mini"
            type="daterange" :value-format="'yyyy-MM-dd'"
            align="left" :unlink-panels="false"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions2">
          </el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" v-model="searchdata" icon="el-icon-search" @click="searchData" size="mini">搜索</el-button>
          <el-button type="warning" v-on:click="add" v-if="!isSupply()" size="mini">新增</el-button>
        </el-col>
      </el-col>

    </div>

    <el-table ref="tableData"
              :data="tableData"
              :height="gettableHeight(112)"
              size="mini"
              stripe :row-style="getStyle"
              border
              style="width: 100%;"
    >
      <el-table-column fixed width="75"
                       label="序号" header-align="center"
                       align="left">
        <template slot-scope="scope">
          <span style="display:inline-block;width:35px;text-align: center;" v-if="!scope.row.parenterpserial">{{getIndex(scope.row,scope.$index)}}</span>
          <span style="cursor: pointer;"
                :class="scope.row.expend==1?'el-icon el-icon-arrow-down':'el-icon el-icon-arrow-right'"
                v-if="scope.row.cstagreementDOList&&scope.row.cstagreementDOList.length>0"
                @click="changeRenderRow(scope.$index,scope.row)"></span>
        </template>
      </el-table-column>
      <el-table-column prop="casestatus" label="状态" align="center" header-align="center" width="70">
        <template slot-scope="scope">
          <span v-if="scope.row.casestatus==0 ||scope.row.casestatus==undefined">待审核</span>
          <span v-if="scope.row.casestatus==6 ">执行中</span>
          <span v-if="scope.row.casestatus==9 ">已返利</span>
          <span v-if="scope.row.casestatus==-1 ">已终止</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="pname" :show-overflow-tooltip="true"
        label="合同名称" fixed
        align="left" width="220"
        header-align="center">
      </el-table-column>
      <el-table-column
        prop="erpserial"
        label="合同编号"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="customername" v-if="showlist"
        label="客户" :show-overflow-tooltip="true"
        align="left" header-align="center"
        width="200">
      </el-table-column>
      <el-table-column v-if="showlist"
                       prop="customerserial"
                       label="客户编号"
                       align="left"
                       header-align="center"
                       width="120">
      </el-table-column>
      <el-table-column v-if="showlist"
                       prop="serveuname"
                       label="业务员"
                       align="left"
                       header-align="center" :show-overflow-tooltip="true"
                       width="90">
      </el-table-column>
      <el-table-column
        prop="jhjgrq"
        label="签订日期"
        align="center"
        width="95">
        <template slot-scope="scope">
          {{scope.row.htqd!=null?scope.row.htqd.substr(0,10):""}}
        </template>
      </el-table-column>
      <el-table-column
        prop="jhjgrq"
        label="截止日期"
        align="center"
        width="95">
        <template slot-scope="scope">
          {{scope.row.jhjgrq!=null?scope.row.jhjgrq.substr(0,10):''}}
        </template>
      </el-table-column>
      <el-table-column
        prop="htje"
        label="合同金额"
        align="right"
        header-align="center"
        width="100">
        <template slot-scope="scope">
          {{scope.row.htje|numeric(2)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="handleoverdate"
        label="返利日期"
        align="right"
        header-align="center"
        width="85">
        <template slot-scope="scope">
          {{scope.row.handleoverdate==undefined?'':scope.row.handleoverdate.substr(0,10)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="uname" :show-overflow-tooltip="true"
        label="添加人"
        align="left"
        header-align="center"
        width="90">
      </el-table-column>
      <el-table-column label="补充协议" align="center" width="80" v-if="!isSupply()" fixed="right">
        <template slot-scope="scope">
          <el-button v-if="!scope.row.parenterpserial"
                     size="mini"
                     @click="addChildContract(scope.$index, scope.row)">新增
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="统计" align="center" width="80" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleTJ(scope.$index, scope.row)">查看
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" header-align="center" align="left" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)" v-if="!isSupply()&&isShowOperateButton(scope.row)">编辑
          </el-button>
          <el-button
            size="mini"
            @click="handleView(scope.$index, scope.row)" v-if="isSupply()||!isShowOperateButton(scope.row)">查看
          </el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)" v-if="isShowOperateButton(scope.row)&&!isSupply()">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="foot" v-if="showlist">
      <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
    </div>
    <SaleContractEdit ref="DataContactEdit" @bindGrid="bindGrid"></SaleContractEdit>
    <ChildContractList ref="ChildContractList"></ChildContractList>
    <SaleContractTJ ref="SaleContractTJ"></SaleContractTJ>
  </div>
</template>
<script>
  import SaleContractEdit from './SaleContractEdit';
  import SaleContractTJ from './SaleContractTJ';
  import ChildContractList from './ChildContractList';
  import {getListData, deleteData} from '@/api/order/salecontract';
  import {independentDept} from '@/api/set/dept';
  import {pickerShortCuts} from '@/plugin/ordercommon';

  export default {
    name: 'SaleContractList',
    data() {
      return {
        msg: 'Welcome to Your Vue.js App',
        dialogFormVisible: false,
        searchdata: "",
        financeRight: false,
        controlData: [],
        pagination: {
          currentPage: 1,
          pageSize: 0,
          total: 0
        },
        tableData: [],
        uguid: '',
        idd: [],//服务中心
        userInfoModel: {},
        tokenModel: {},
        serveuguid:'',
        serveuname:'',
        servedserial: '',//服务中心编码
        servedname: '',//服务中心名称,
        casestatus: "",//审批状态
        casestatuses: [{value: 0, name: "待审核"}, {value: 6, name: "执行中"}, {value: 9, name: "已返利"}, {
          value: -1,
          name: "已终止"
        }],
        isClickEvent: true,//选择供应商、客户清空图标按钮不触发click事件使用
        customerserial: "",//门店编号
        customername: "",//门店
        searchdatevalue: [],//时间段
        pickerOptions2: {
          shortcuts: []
        },
      }
    },
    props: {
      showlist: {
        default: true,
      },
      searchcustomerserial: {
        default: ''
      },
      searchcustomername: {
        default: ''
      },
      canEdit: {
        default: true,
      }
    },
    methods: {
      //业务员
      changeServer(guids, names, arr) {
        this.serveuguid = guids;
        this.serveuname = names;
      },
      gettableHeight(cut) {
        if (this.showlist) {
          return this.tableHeight(cut);
        } else {
          return null;
        }
      },
      isSupply() {
        return !this.canEdit;
      },
      isZongBu() {//只有总部人员能操作
        return this.userInfoModel.independentserial == null || this.userInfoModel.independentserial == ""
      },
      //获取序号
      getIndex(row, index) {
        let result = 0
        if (!row.parenterpserial) {
          for (let i = 0; i <= index; i++)
            if (!this.tableData[i].parenterpserial) {
              result++
            }
        }
        result += (this.pagination.currentPage - 1) * this.pagination.pageSize
        return result
      },
      //获取样式
      getStyle(data, index) {
        if (data.row.show == 1 || !data.row.parenterpserial) {
          return {display: ""}
        } else {
          return {display: 'none'}
        }
      },
      //点击展开按钮
      changeRenderRow(index, row) {
        if (row.expend == 1) {
          this.$set(row, "expend", 0)
          this.tableData.forEach(o => {
            if (o.parenterpserial == row.erpserial) {
              this.$set(o, "show", 0)
            }
          })
        } else {
          this.$set(row, "expend", 1)
          this.tableData.forEach(o => {
            if (o.parenterpserial == row.erpserial) {
              this.$set(o, "show", 1)
            }
          })
        }
      },
      // //查询条件的选择门店
      // showSelectAllCustomerName() {
      //   if (this.isClickEvent) {
      //     this.$refs.externaldeptsel.show(1, '选择门店')
      //   } else {
      //     this.isClickEvent = true
      //   }
      // },
      //选择门店之后执行
      afterSelExternalDept(customerserial, customername, row) {
        this.customername = customername
        this.customerserial = customerserial
        this.bindGrid()
      },
      clearCustomerName() {
        // this.isClickEvent = false
        this.customerserial = ""
        this.customername = ""
        this.bindGrid()
      },
      //显示删除\编辑按钮
      isShowOperateButton(row) {
        if ((!row.casestatus && this.uguid == row.uguid) || (!row.casestatus && this.isZongBu() && this.$checkRight('财务')) || (row.casestatus == 6 && this.isZongBu() && this.$checkRight('财务'))) {
          return true
        }
        return false
      },
      handleTJ(index, row) {
        this.$refs.SaleContractTJ.initData(row);
      },
      handleChild(index, row) {
        this.$refs.ChildContractList.show(row)
      },
      //添加子合同
      addChildContract(index, row) {
        this.$refs.DataContactEdit.initForm()
        this.$refs.DataContactEdit.show(row.erpserial, row.unitguid, row.customerserial, row.customername)
      },
      handleEdit(index, row) {
        this.$refs.DataContactEdit.initData(row.unitguid);
      },
      handleView(index, row) {
        this.$refs.DataContactEdit.initData(row.unitguid, false);
      },
      handleDelete(index, row) {
        this.$confirm('是否确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteData({unitguid: row.unitguid, erpserial: row.erpserial}).then(response => {
            if (response.data.code == 0) {
              this.bindGrid();
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
            } else {
              this.$message({
                type: 'error',
                duration: 1500,
                message: response.data.msg
              })
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });


      },
      searchData() {
        this.pagination.total = 0
        this.pagination.currentPage = 1
        this.bindGrid()
      },
      bindGrid(cusserial) {
        this.tableData = []
        var startDate = this.searchdatevalue.length > 0 ? new Date(this.searchdatevalue[0]) : "";
        var endDate = this.searchdatevalue.length > 0 ? new Date(this.searchdatevalue[1]) : "";
        if (!this.showlist) {
          if (cusserial)
            this.customerserial = cusserial;
          else
            this.customerserial = this.searchcustomerserial;
          if (this.customerserial == '') {
            this.tableData.splice(0, this.tableData.length);
            return;
          }
          this.pagination.currentPage = 1;
          this.pagination.pageSize = 100;
        }
        getListData({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          search: this.searchdata,
          parenterpserialempty: '1',
          applybydserial: this.servedserial,//服务中心筛选
          casestatus: this.casestatus,
          customerserial: this.customerserial,
          serveuguid: this.financeRight ? "" : this.userInfoModel.uguid,
          searchserveuguid:this.serveuguid,
          startdate: startDate == "" ? "" : startDate.getFullYear() + '-' + ((startDate.getMonth() < 9 ? "0" : "") + (startDate.getMonth() + 1)) + "-" + (startDate.getDate() < 9 ? "0" : "") + startDate.getDate(),
          enddate: endDate == "" ? "" : endDate.getFullYear() + '-' + (endDate.getMonth() + 1) + "-" + endDate.getDate(),
        }).then(response => {
          this.pagination.total = response.data.obj.total
          let index = 0
          response.data.obj.rows.forEach(o => {
            o.expend = 1
            this.tableData.splice(index, 0, o)
            index++
            o.cstagreementDOList.forEach((o2, j) => {
              o2.show = 1
              this.tableData.splice(index, 0, o2)
              index++
            })

          })

        }).catch((error) => {
        });
      },
      add() {
        this.$refs.DataContactEdit.initForm()
        this.OpenDialog()
        if (!this.showlist)
          this.$refs.DataContactEdit.selectExternalDept(this.searchcustomerserial, this.searchcustomername);
      },
      OpenDialog() {
        this.$refs.DataContactEdit.show()
      }
    },
    mounted() {
      this.tokenModel = JSON.parse(localStorage.getItem("hpapi_tokenModel"))
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      this.uguid = this.userInfoModel.uguid
      this.servedserial = this.userInfoModel.independentserial;
      this.servedname = this.userInfoModel.tenantname
      this.pickerOptions2.shortcuts = pickerShortCuts();
      independentDept().then(response => {
        this.idd = response.data.obj
        if (this.userInfoModel.independentserial == "") {
          this.idd.unshift({serialnum: "all", dname: "全部"})
          this.servedserial = 'all';
          if (this.$checkRight("财务")) {
            this.financeRight = true;
          } else {//只保留总部的
            // this.idd = this.idd.filter(o => {
            //   return o.serialnum == ""
            // })
          }
        }
        this.bindGrid();
      })
    },
    components: {
      SaleContractEdit,
      ChildContractList,
      SaleContractTJ,
      // ExternaldeptSel

    }

  }


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .distpicker-address-wrapper {
    display: inline-block;
    position: relative;
    top: 2px;
  }

  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/testorder/salecontract/SaleContractList.vue